import { useNavigate } from 'react-router-dom';

/**
 * 登入流程子頁（客服、語言）共用外殼
 */
export default function AuthSubPageShell({ title, children }) {
  const navigate = useNavigate();

  return (
    <div className="auth-sub-page">
      <header className="auth-sub-page__header">
        <button
          type="button"
          className="auth-sub-page__back"
          aria-label="返回"
          onClick={() => navigate(-1)}
        >
          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" aria-hidden>
            <path
              d="M15 6l-6 6 6 6"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
        <h1 className="auth-sub-page__title">{title}</h1>
        <span className="auth-sub-page__spacer" aria-hidden />
      </header>
      <div className="auth-sub-page__body">{children}</div>
    </div>
  );
}
